import { NgModule } from "@angular/core";
import { PageHeaderComponent } from "./components/page-header/page-header.component";
import { TableComponent } from "./components/table/table.component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TabViewModule } from "primeng/tabview";
import { CalendarModule } from "primeng/calendar";
import { PaginationModule, RatingModule } from "ngx-bootstrap";
import { QRCodeModule } from "angularx-qrcode";
import { InputSearchBoxComponent } from "./components/input-search-box/input-search-box.component";
import { DetailsCardComponent } from "./components/details-card/details-card.component";
import { DriverLicenceFormComponent } from "./components/driver-licence-form/driver-licence-form.component";
import { DropdownFieldBoxComponent } from "./components/dropdown-field-box/dropdown-field-box.component";
import { FileUploadBoxComponent } from "./components/file-upload-box/file-upload-box.component";
import { InputDateTimeFieldBoxComponent } from "./components/input-date-time-field-box/input-date-time-field-box.component";
import { MapDetailsCardComponent } from "./components/map-details-card/map-details-card.component";
import { PaginationCustomComponent } from "./components/pagination/pagination.component";
import { RegistrationDocsFormComponent } from "./components/registration-docs-form/registration-docs-form.component";
import { ToggleSwitchBoxComponent } from "./components/toggle-switch-box/toggle-switch-box.component";
import { ViewEditUserImageBoxComponent } from "./components/view-edit-user-image-box/view-edit-user-image-box.component";
import { NgbModule, NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { ReactiveFormsModule } from "@angular/forms";
import { SplitButtonModule } from "primeng/splitbutton";
import { SidebarModule } from "primeng/sidebar";
import { FilterBoxComponent } from "./components/filter-box/filter-box.component";
import { TooltipModule } from "primeng/tooltip";
import { MenuModule } from "primeng/menu";
import { DriverService } from "./services/driver/driver.service";
import { AddressDetailsFormComponent } from "./components/address-details-form/address-details-form.component";
import { InputSwitchModule } from "primeng/inputswitch";
import { ContentViewModalComponent } from "./components/content-view-modal/content-view-modal.component";
import { CommonService } from "./services/commen/commen.services";
import { UppercaseNumberPipe } from "./pipe/uppercaseNumber.pipe";
import { NumberFormatPipe } from "./pipe/number-format1.pipe";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { AutoCompleteModule } from "primeng/autocomplete";
import { AccordionModule } from "primeng/accordion";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { MainHeaderComponent } from "./components/main-header/main-header.component";
import { MainFooterComponent } from "./components/main-footer/main-footer.component";
import { NewDefaultPageComponent } from "./components/new-default-page/new-default-page.component";
import { PanelMenuModule } from "primeng/panelmenu";
import { TablePattern1Component } from "./components/table-pattern1/table-pattern1.component";
import { EntityService } from "./services/entity/entity.service";
import { AttachmentListComponent } from "./components/attachment-list/attachment-list.component";
import { MastersService } from "./services/masters/masters.service";
import { EmptyPageComponent } from "./components/empty-page/empty-page.component";
import { ConfirmationPopupComponent } from "./components/confirmation-popup/confirmation-popup.component";
import { ConfirmationPopup_warningComponent } from "./components/confirmation-popup-warning/confirmation-popup-warning.component";
import { ToastComponent } from "./components/toast/toast.component";
import { CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { ChartOfAccountsService } from "./services/chartOfAccounts/chartOfAccounts.service";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { MenuListComponent } from "./components/menu-list/menu-list.component";
import { OrdersService } from "./services/orders/orders.service";
import { TripmapComponent } from "./components/tripmap/tripmap.component";
import { SharedModule } from "../freightconfirmation/app.sharemodule";
import { NewDetailCardComponent } from './components/new-detail-card/new-detail-card.component';
import { NewcustomerHeaderComponent } from './components/newcustomer-header/newcustomer-header.component';
import { RechargeformComponent } from "../wallet/rechargeform/rechargeform.component";
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { CommanattachdocumentsComponent } from './components/commanattachdocuments/commanattachdocuments.component';
import { RatingCardComponent } from './components/rating-card/rating-card.component';
import { ShipmentsComponent } from './components/shipments/shipments.component';
import { NewRegistrationUploadComponent } from './components/new-registration-upload/new-registration-upload.component';
import { SelfFulfilledComponent } from './components/self-fulfilled/self-fulfilled.component';
import { ContractedComponent } from './components/contracted/contracted.component';
import { BiddingComponent } from './components/bidding/bidding.component';
import { ShipnowPopupComponent } from './components/shipnow-popup/shipnow-popup.component';
import { NewBidsettingsPopupComponent } from './components/new-bidsettings-popup/new-bidsettings-popup.component';
import { DetailHeaderByIdComponent } from './components/detail-header-by-id/detail-header-by-id.component';
import { NewBidDetailsComponent } from "./components/new-bid-details/new-bid-details.component";
import { NewRateHistoryComponent } from './components/new-rate-history/new-rate-history.component';
import { ExpenseBifurcationComponent } from './components/expense-bifurcation/expense-bifurcation.component';
import { NewShipmentPageComponent } from './components/new-shipment-page/new-shipment-page.component';
import { PrintReportComponent } from './components/print-report/print-report.component';
import { TruckLoadViewComponent } from './components/truck-load-view/truck-load-view.component';
import { TransactionTabComponent } from './components/transaction-tab/transaction-tab.component';
import { TripsTransactionComponent } from './components/trips-transaction/trips-transaction.component';
import { BillsTransactionComponent } from './components/bills-transaction/bills-transaction.component';
import { ExpenseTransactionComponent } from './components/expense-transaction/expense-transaction.component';
import { DownloadViaInputsComponent } from './components/download-via-inputs/download-via-inputs.component';
import { JournalEntryTransactionComponent } from './components/journal-entry-transaction/journal-entry-transaction.component';
import { LoginLogTransactionComponent } from './components/login-log-transaction/login-log-transaction.component';
import { InvoiceTransactionComponent } from './components/invoice-transaction/invoice-transaction.component';
import { OutstandingTransactionComponent } from './components/outstanding-transaction/outstanding-transaction.component';
import { SalesOrderTransactionComponent } from './components/sales-order-transaction/sales-order-transaction.component';
import { prd_ProductList_commonComponent } from './components/prd_ProductList_common/prd_ProductList_common.component';
import { OutwardTransactionComponent } from './components/outward-transaction/outward-transaction.component';
import { OrdersTransactionComponent } from './components/orders-transaction/orders-transaction.component';
import { StocksTransactionComponent } from './components/stocks-transaction/stocks-transaction.component';
import { InwardsTransactionComponent } from "./components/inwards-transaction/inwards-transaction.component";
import { PurchaseOrderTransactionComponent } from './components/purchase-order-transaction/purchase-order-transaction.component';
import { ReturnSalesOrderTransactionComponentComponent } from './components/return-sales-order-transaction-component/return-sales-order-transaction-component.component';
import { EwaybillTransactionComponent } from './components/ewaybill-transaction/ewaybill-transaction.component';
import { ReturnPurchaseOrderComponent } from './components/return-purchase-order/return-purchase-order.component';
import { ShipmentTransactionsComponent } from './components/shipment-transactions/shipment-transactions.component';
import { BillpaymentsTransactionComponent } from './components/billpayments-transaction/billpayments-transaction.component';
import { MaintainanceTransactionComponent } from './components/maintainance-transaction/maintainance-transaction.component';
import { FtlCostSheetComponent } from './components/ftl-cost-sheet/ftl-cost-sheet.component';
import { NewPrintFormatsComponent } from './components/new-print-formats/new-print-formats.component';
import { NgxBarcodeModule } from "ngx-barcode";
import { PrintFormatsModule } from "../print-formats/print-formats.module";
import { ReportHeaderComponent } from './components/report-header/report-header.component';
import { LegderModalComponent } from "../Reports/NewAccounts/new-accounts/legder-modal/legder-modal.component";
import { PrintFormatsNewComModule } from "../print-formats-new/print-formats-new.module";
import { TransporterVehicleDriverCardModalComponent } from './components/transporter-vehicle-driver-card-modal/transporter-vehicle-driver-card-modal.component';
import { TripExpenseComponent } from './components/trip-expense/trip-expense.component';
import { RecordIncomeComponent } from './components/record-income/record-income.component';
import { ChangeTranporterDriverHistoryComponent } from './components/change-tranporter-driver-history/change-tranporter-driver-history.component';
import { NewTripMilestonesComponent } from './components/new-trip-milestones/new-trip-milestones.component';
import { DragDropModule } from 'primeng/dragdrop';
import { ChatProfilesComponent } from './components/chat-profiles/chat-profiles.component';
import { PopUpChatComponent } from './components/pop-up-chat/pop-up-chat.component';
import { InspectionChecklistComponent } from './components/inspection-checklist/inspection-checklist.component';
import { SelfFulfilledModule } from "./components/self-fulfilled/self-fulfilled.module";
import { AddWithULIPComponent } from './components/add-with-ulip/add-with-ulip.component';
import { ShipnowVehicleAssignComponent } from "../newship-now/shipnow-vehicle-assign/shipnow-vehicle-assign.component";
import { EditaddressComponent } from "../full-truck-load/ftldetails/editaddress/editaddress.component";
import { PrintNameListComponent } from './components/print-name-list/print-name-list.component';
import { HistoryTooltipComponent } from './components/history-tooltip/history-tooltip.component';
import { CommonDropdownlistComponent } from './components/common-dropdownlist/common-dropdownlist.component';
import { NewCommonLocationsComponent } from './components/new-common-locations/new-common-locations.component';
import { PlainDecimalPipe } from "./components/table/custom-number.pipe";
import { SendMailComponent } from './components/send-mail/send-mail.component';
import { UpdateShipmentDetailsComponent } from './components/update-shipment-details/update-shipment-details.component';
import { UnconfirmWithReasonComponent } from './components/unconfirm-with-reason/unconfirm-with-reason.component';
import { DigitalSigninComponent } from './components/digital-signin/digital-signin.component';
import { NewIssueModalModule } from "./components/new-issue-modal/new-issue-modal.module";
import { QuotationlogComponent } from './components/quotationlog/quotationlog.component';
import { SendingMailSharedModule } from "../sending-mail/sending-mail_shared.module";
import { CommonCancelWithReasonComponent } from './components/common-cancel-with-reason/common-cancel-with-reason.component';
import { ContractedRateBreakupModalComponent } from './components/contracted-rate-breakup-modal/contracted-rate-breakup-modal.component';
import { NewAiSuggestionComponent } from './components/new-ai-suggestion/new-ai-suggestion.component';
import { UlipService } from "./services/Ulip/ulip.service";
import { NewUlipComponent } from './components/new-ulip/new-ulip.component';
import { EwayBillService } from "./services/EwayBill/eway-bill.service";
import { EwayBillLogComponent } from './components/eway-bill-log/eway-bill-log.component';
import { BidRequestRateBreakupModalComponent } from './components/bid-request-rate-breakup-modal/bid-request-rate-breakup-modal.component';
import { AddOrdersToTripComponent } from './components/add-orders-to-trip/add-orders-to-trip.component';
import { CreateTripWithoutOrderComponent } from './components/create-trip-without-order/create-trip-without-order.component';
import { NewChangeOriginAndDestinationComponent } from './components/new-change-origin-and-destination/new-change-origin-and-destination.component';
import { DMRAddOrderModalComponent } from './components/dmradd-order-modal/dmradd-order-modal.component';
import { ChangeTransVehDriverComponent } from './components/change-trans-veh-driver/change-trans-veh-driver.component';
import { ExtendEwayBillComponent } from './components/extend-eway-bill/extend-eway-bill.component';
import { NewBulkOrderUploadComponent } from './components/new-bulk-order-upload/new-bulk-order-upload.component';
import { NewEditSelectedBulkOrderComponent } from './components/new-edit-selected-bulk-order/new-edit-selected-bulk-order.component';
import { ChartOfAccountFormComponent } from './components/chart-of-account-form/chart-of-account-form.component';
import { DynamicReportModalComponent } from './components/dynamic-report-modal/dynamic-report-modal.component';
import { GenerateManualLoadingPlanComponent } from './components/generate-manual-loading-plan/generate-manual-loading-plan.component';
import { DriverConsentComponent } from './components/driver-consent/driver-consent.component';
import { CreateNewCustomerComponent } from './components/create-new-customer/create-new-customer.component';
import { VehicleService } from "./services/vehicle/vehicle.service";
import { CancelEInvoiceComponent } from './components/cancel-einvoice/cancel-einvoice.component';
import { ShipmentAuditTrailComponent } from './components/shipment-audit-trail/shipment-audit-trail.component';
import { NotesModule} from '../notes/notes.module' // added by yash 23/04/2026
import { EwayBillSettingComponent } from './components/eway-bill-setting/eway-bill-setting.component';
import { ConsignmentsService } from "./services/Consignments/Consignments.service";
import { ProductPalletFormComponent } from './components/product-pallet-form/product-pallet-form.component';
import { OrderManagementSummaryComponent } from './components/order-management-summary/order-management-summary.component';
import { ManifestService } from "./services/manifest-API/order-manifest.service";
import { CancelEwayBillModalComponent } from './components/cancel-eway-bill-modal/cancel-eway-bill-modal.component';
import { OrderWaveSummaryComponent } from './components/order-wave-summary/order-wave-summary.component';
// import { SharedMapComponent } from './components/shared-map/shared-map.component';
// import { MessageService } from "primeng/api";
// import { ToastModule } from 'primeng/toast';
// import { DetailsComponent } from "../new-network/network-details-by-id/details/details.component";//add by burhan - 16-Jan-2026
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

const componentList = [
  PageHeaderComponent,
  NewAiSuggestionComponent,//add by burhan - 13-Jan-2026
  TableComponent,
  InputSearchBoxComponent,
  DetailsCardComponent,
  DriverLicenceFormComponent,
  DropdownFieldBoxComponent,
  FileUploadBoxComponent,
  InputDateTimeFieldBoxComponent,
  MapDetailsCardComponent,
  PaginationCustomComponent,
  RegistrationDocsFormComponent,
  ToggleSwitchBoxComponent,
  ViewEditUserImageBoxComponent,
  FilterBoxComponent,
  AddressDetailsFormComponent,
  ContentViewModalComponent,
  NewDefaultPageComponent,
  MainHeaderComponent,
  MainFooterComponent,
  EmptyPageComponent,
  TablePattern1Component,
  AttachmentListComponent,
  // DetailsComponent,//add by burhan - 16-Jan-2026
  ConfirmationPopupComponent,
  ConfirmationPopup_warningComponent,
  ToastComponent,
  MenuListComponent,
  TripmapComponent,
  NewDetailCardComponent,
  NewcustomerHeaderComponent,
  StarRatingComponent,
  CommanattachdocumentsComponent,
  RatingCardComponent,
  ShipmentsComponent,
  StarRatingComponent
  , CommanattachdocumentsComponent
  , NewRegistrationUploadComponent,
  // StarRatingComponent,
  // CommanattachdocumentsComponent,
  RatingCardComponent,
  // RechargeformComponent,
  // NumberFormatPipe
  SelfFulfilledComponent,
  ContractedComponent,
  BiddingComponent,
  ShipnowPopupComponent,
  NewBidsettingsPopupComponent,
  DetailHeaderByIdComponent,
  // NewBidDetailsComponent,
  NewRateHistoryComponent,
  ExpenseBifurcationComponent,
  NewShipmentPageComponent,
  PrintReportComponent,
  TruckLoadViewComponent,
  DownloadViaInputsComponent,
  TruckLoadViewComponent,
  TransactionTabComponent,
  TripsTransactionComponent,
  BillsTransactionComponent,
  ExpenseTransactionComponent,
  JournalEntryTransactionComponent,
  LoginLogTransactionComponent,
  InvoiceTransactionComponent,
  OutstandingTransactionComponent,
  SalesOrderTransactionComponent,
  prd_ProductList_commonComponent,
  OutwardTransactionComponent,
  OrdersTransactionComponent,
  StocksTransactionComponent,
  InwardsTransactionComponent,
  PurchaseOrderTransactionComponent,
  ReturnSalesOrderTransactionComponentComponent,
  EwaybillTransactionComponent,
  ReturnPurchaseOrderComponent,
  FtlCostSheetComponent,
  ShipmentTransactionsComponent,
  BillpaymentsTransactionComponent,
  MaintainanceTransactionComponent,
  ReportHeaderComponent,
  LegderModalComponent,
  FtlCostSheetComponent,
  NewPrintFormatsComponent,
  TransporterVehicleDriverCardModalComponent,
  ChangeTranporterDriverHistoryComponent,
  NewTripMilestonesComponent,
  AddWithULIPComponent,
  ShipnowVehicleAssignComponent,
  EditaddressComponent,
  PrintNameListComponent,
  RecordIncomeComponent,
  HistoryTooltipComponent,
  CommonDropdownlistComponent,
  NewCommonLocationsComponent,
  PlainDecimalPipe,
  SendMailComponent,
  UpdateShipmentDetailsComponent,
  UnconfirmWithReasonComponent,
  DigitalSigninComponent,
  QuotationlogComponent,
  CommonCancelWithReasonComponent,
  ContractedRateBreakupModalComponent,  //added by fahim 2-1-2026 :)
  NewUlipComponent, // Added by priya - 20/01/2026 - cn(PRIYA-JAN26-013)
  EwayBillLogComponent // Added by priya - 28/01/2026 - cn(PRIYA-JAN26-014)
  ,BidRequestRateBreakupModalComponent //added by fahim 29-1-2026 :)
  ,AddOrdersToTripComponent //added by fahim 29-1-2026 :)
  ,CreateTripWithoutOrderComponent //added by fahim 29-1-2026 :)
  ,NewChangeOriginAndDestinationComponent //added by fahim 29-1-2026 :)
  ,TripExpenseComponent //added by fahim 29-1-2026 :)
  ,DMRAddOrderModalComponent //added by fahim 29-1-2026 :)
  , ChangeTransVehDriverComponent // Added by priya - 09/02/2026 - cn(PRIYA-JAN26-017)
  , ExtendEwayBillComponent // Added by priya - 10/02/2026 - cn(PRIYA-JAN26-017)
  ,NewBulkOrderUploadComponent //added by fahim 10-02-2026 :)
  ,NewEditSelectedBulkOrderComponent //added by fahim 10-02-2026 :)
  ,ChartOfAccountFormComponent //added by fahim 28-02-2026 :)
  ,DynamicReportModalComponent //added by fahim 05-03-2026 :)
  ,GenerateManualLoadingPlanComponent //added by fahim 30-03-2026 :)
  ,DriverConsentComponent // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
  ,CreateNewCustomerComponent // Added by priya - 14/04/2026 - cn(PRIYA-APR26-006)
  ,CancelEInvoiceComponent // Added by Fahim 25-04-2026
  ,ShipmentAuditTrailComponent // Added by Fahim 05-05-2026
  , EwayBillSettingComponent // Added by priya - 27/05/2026 - cn(PRIYA-MAY26-010)
  , ProductPalletFormComponent
  , OrderManagementSummaryComponent
  , CancelEwayBillModalComponent
  , OrderWaveSummaryComponent
];
@NgModule({
    declarations: [componentList, UppercaseNumberPipe, TripmapComponent, NumberFormatPipe, TripExpenseComponent,  ChatProfilesComponent, PopUpChatComponent, InspectionChecklistComponent, DigitalSigninComponent, 
      // ,AttachmentListComponent,DetailsComponent,//This 2 added by burhan - 16-Jan-2026
    ],
  exports: [componentList,
    //added by burhan - 16-Jan-2026
    // AttachmentListComponent,DetailsComponent
    //end by burhan
    // ShipnowVehicleAssignSharedModule
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    TabViewModule,
    CalendarModule,
    NgbTypeaheadModule,
    ReactiveFormsModule,
    SplitButtonModule,
    SidebarModule,
    MenuModule,
    TooltipModule,
    NgbDropdownModule,
    AccordionModule,
    AutoCompleteModule,
    PanelMenuModule,
    NgSelectModule,
    OverlayPanelModule,
    // ToastModule,
    NgbModule.forRoot(),
    InputSwitchModule,
    CheckboxModule,
    RadioButtonModule,
    PaginationModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    SharedModule,
    RatingModule,
    NgxBarcodeModule,
    PrintFormatsModule,
    PrintFormatsNewComModule,
    DragDropModule,
    QRCodeModule,
    NewIssueModalModule,
    SendingMailSharedModule,
    NotesModule, // added by yash 23/04/2026
    // SelfFulfilledModule
  ],
  providers: [
    DriverService,
    CommonService,
    EntityService,
    TranslateConfigService,
    // MessageService,
    MastersService,
    ToastComponent,
    ChartOfAccountsService,
    OrdersService,
    UlipService,
    EwayBillService,
    VehicleService,
    ConsignmentsService,
    ManifestService
  ],
  entryComponents: [
    ConfirmationPopupComponent,
    ConfirmationPopup_warningComponent,
    CommanattachdocumentsComponent,
    ShipnowPopupComponent,
    NewBidsettingsPopupComponent,
    DetailHeaderByIdComponent,
    AttachmentListComponent,
    TransporterVehicleDriverCardModalComponent,
    ChangeTranporterDriverHistoryComponent,
    AddWithULIPComponent,
    DetailsCardComponent,
    CommonCancelWithReasonComponent,
    ContractedRateBreakupModalComponent  //added by fahim 2-1-2026 :)
   ,BidRequestRateBreakupModalComponent  //added by fahim 29-1-2026 :)
   ,AddOrdersToTripComponent  //added by fahim 29-1-2026 :)
   ,CreateTripWithoutOrderComponent  //added by fahim 29-1-2026 :)
   ,NewChangeOriginAndDestinationComponent  //added by fahim 29-1-2026 :)
   ,DMRAddOrderModalComponent  //added by fahim 29-1-2026 :)
    , ChangeTransVehDriverComponent // Added by priya - 09/02/2026 - cn(PRIYA-JAN26-017)
    , ExtendEwayBillComponent // Added by priya - 10/02/2026 - cn(PRIYA-JAN26-017)
   ,NewBulkOrderUploadComponent  //added by fahim 10-2-2026 :)
   ,NewEditSelectedBulkOrderComponent  //added by fahim 10-2-2026 :)
   ,ChartOfAccountFormComponent  //added by fahim 28-2-2026 :)
   ,DynamicReportModalComponent //added by fahim 05-03-2026 :)
   ,GenerateManualLoadingPlanComponent //added by fahim 30-03-2026 :)
    ,DriverConsentComponent // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
    ,CreateNewCustomerComponent // Added by priya - 14/04/2026 - cn(PRIYA-APR26-006)
    ,CancelEInvoiceComponent // Added by Fahim 25-04-2026
    ,ShipmentAuditTrailComponent // Added by Fahim 05-05-2026
    , EwayBillSettingComponent // Added by priya - 27/05/2026 - cn(PRIYA-MAY26-010)
    , ProductPalletFormComponent
    ,OrderManagementSummaryComponent
    , CancelEwayBillModalComponent
    , OrderWaveSummaryComponent
  ],
})
export class SharedComponentModule { }


